import { render, staticRenderFns } from "./jovenes.vue?vue&type=template&id=898a7fc6&"
import script from "./jovenes.vue?vue&type=script&lang=js&"
export * from "./jovenes.vue?vue&type=script&lang=js&"
import style0 from "./jovenes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports